import React from "react";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import Status from "@acadia-ui/status";
import "./icons.scss";

export default function TraffickingIcon({ statusMessage, type, position = TOOLTIP_POSITION.AUTO }) {
	return (
		<Tooltip title={statusMessage} position={position}>
			<Status type={type} title={statusMessage} />
		</Tooltip>
	);
}
